export default __webpack_public_path__ + "static/media/ar-holding-coffee.84dde453.webp";